import { render, staticRenderFns } from "./ScrapSource.vue?vue&type=template&id=8f6ab494&scoped=true&"
import script from "./ScrapSource.vue?vue&type=script&lang=js&"
export * from "./ScrapSource.vue?vue&type=script&lang=js&"
import style0 from "./ScrapSource.vue?vue&type=style&index=0&id=8f6ab494&scoped=true&lang=css&"
import style1 from "./ScrapSource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6ab494",
  null
  
)

export default component.exports